/**
 * 白名单页面
 */

export const whiteList = ["/login", "/404", "/project"];
